import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import ServiceDetail from './pages/ServiceDetail';
import Projects from "./pages/Projects";
import Gallery from "./pages/Gallery";
import Contact from './pages/Contact';
import PageNotFound from "./pages/PageNotFound";
import Header from './components/Header';
import Footer from './components/Footer';
import CustomCursor from './components/CustomCursor';
import PillNavDemo from './pages/PillNavDemo';
import SocialSidebar from './components/SocialSidebar';
import ScrollToTop from './components/ScrollToTop';
import Blog from './pages/Blog';
import BlogDetail from './pages/BlogDetail';
import './assets/css/bootstrap.min.css';
import './assets/css/slicknav.min.css';
import './assets/css/swiper-bundle.min.css';
import './assets/css/all.min.css';
import './assets/css/animate.css';
import './assets/css/magnific-popup.css';
import './assets/css/mousecursor.css';
import './assets/css/custom.css';

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';

import LoaderLogo from './assets/images/eralogofinal.svg';
gsap.registerPlugin(ScrollTrigger, SplitText);

function App() {
  // ✅ Handle preloader logic
  useEffect(() => {
    const handleLoad = () => {
      const preloader = document.querySelector('.preloader');
      if (preloader) {
        preloader.style.transition = 'opacity 0.6s ease';
        preloader.style.opacity = '0';

        setTimeout(() => {
          preloader.style.display = 'none';
        }, 2000);
      }
    };

    if (document.readyState === 'complete') {
      handleLoad();
    } else {
      window.addEventListener('load', handleLoad);
    }

    return () => {
      window.removeEventListener('load', handleLoad);
    };
  }, []);

  // ✅ Handle GSAP text animations
  useEffect(() => {
    // Text Effect 1
    const style1Elements = document.querySelectorAll('.text-anime-style-1');
    style1Elements.forEach((element) => {
      const split = new SplitText(element, { type: 'chars, words' });
      gsap.from(split.words, {
        duration: 1,
        delay: 0.5,
        x: 20,
        autoAlpha: 0,
        stagger: 0.05,
        scrollTrigger: {
          trigger: element,
          start: 'top 85%',
        },
      });
    });

    // Text Effect 2
    const style2Elements = document.querySelectorAll('.text-anime-style-2');
    style2Elements.forEach((element) => {
      const split = new SplitText(element, { type: 'chars, words' });
      gsap.from(split.chars, {
        duration: 1,
        delay: 0.1,
        x: 20,
        autoAlpha: 0,
        ease: 'power2.out',
        stagger: 0.03,
        scrollTrigger: {
          trigger: element,
          start: 'top 85%',
        },
      });
    });

    // Text Effect 3
    const style3Elements = document.querySelectorAll('.text-anime-style-3');
    style3Elements.forEach((element) => {
      if (element.animation) {
        element.animation.progress(1).kill();
        element.split?.revert();
      }

      element.split = new SplitText(element, {
        type: 'lines,words,chars',
        linesClass: 'split-line',
      });

      gsap.set(element, { perspective: 400 });
      gsap.set(element.split.chars, { opacity: 0, x: 50 });

      element.animation = gsap.to(element.split.chars, {
        scrollTrigger: {
          trigger: element,
          start: 'top 90%',
        },
        x: 0,
        y: 0,
        rotateX: 0,
        opacity: 1,
        duration: 1,
        ease: 'back.out',
        stagger: 0.02,
      });
    });

    // Cleanup for split text
    return () => {
      document.querySelectorAll('.text-anime-style-3').forEach((element) => {
        if (element.split) {
          element.split.revert();
        }
      });
    };
  }, []);

  return (
    <BrowserRouter>
      {/* Scroll to top on route change (smooth, skips hash anchors) */}
      <ScrollToTop smooth />
      {/* ✅ Preloader */}
      <div className="preloader">
        <div className="loading-container">
          <div className="loading"></div>
          <div id="loading-icon">
            <img src={LoaderLogo} alt="Loading..." />
          </div>
        </div>
      </div>

      {/* ✅ Custom cursor */}
      <CustomCursor />

      {/* ✅ App Layout */}
      <SocialSidebar />
      <Header />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/blog" element={<Blog />} />
<Route path="/services/:slug" element={<ServiceDetail />} />
{/* Old service URLs → New SEO URLs */}

<Route
  path="/services/1"
  element={
    <Navigate
      to="/services/residential-interior-design"
      replace
    />
  }
/>

<Route
  path="/services/2"
  element={
    <Navigate
      to="/services/Furniture-And-Home-Decor"
      replace
    />
  }
/>

<Route
  path="/services/3"
  element={
    <Navigate
      to="/services/Commercial-Interior-Design"
      replace
    />
  }
/>

<Route
  path="/services/4"
  element={
    <Navigate
      to="/services/Interior-Lighting-Design"
      replace
    />
  }
/>

<Route
  path="/services/5"
  element={
    <Navigate
      to="/services/home-interior-colour"
      replace
    />
  }
/>

<Route
  path="/services/6"
  element={
    <Navigate
      to="/services/Best-3D-Home-Interior-designer"
      replace
    />
  }
/>
        <Route path="/projects" element={<Projects />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/pill-nav-demo" element={<PillNavDemo />} />
        <Route path="*" element={<PageNotFound />} />
      <Route path="/blog/:slug" element={<BlogDetail />} />
      </Routes>

      <Footer />
    </BrowserRouter>
  );
}

export default App;